import { render, staticRenderFns } from "./HomeButtom.vue?vue&type=template&id=015b345e&scoped=true"
import script from "./HomeButtom.vue?vue&type=script&lang=js"
export * from "./HomeButtom.vue?vue&type=script&lang=js"
import style0 from "./HomeButtom.vue?vue&type=style&index=0&id=015b345e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015b345e",
  null
  
)

export default component.exports